import {Component, Input, OnInit} from '@angular/core';
import {
    ChartComponent,
    ApexAxisChartSeries,
    ApexChart,
    ApexXAxis,
    ApexDataLabels,
    ApexStroke,
    ApexMarkers,
    ApexYAxis,
    ApexGrid,
    ApexTitleSubtitle,
    ApexPlotOptions,
    ApexTooltip,
    ApexLegend,
} from 'ng-apexcharts';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    dataLabels: ApexDataLabels;
    markers: ApexMarkers;
    colors: string[];
    yaxis: ApexYAxis;
    grid: ApexGrid;
    legend: ApexLegend;
    title: ApexTitleSubtitle;
    tooltip: ApexTooltip;
    plotOptions: ApexPlotOptions;
};
@Component({
    selector: 'app-admission-chart',
    templateUrl: './admission-chart.component.html',
    styleUrls: ['./admission-chart.component.scss']
})
export class AdmissionChartComponent implements OnInit {
    public areaChartOptions!: Partial<ChartOptions>;
    @Input() centreNames: string[] = []
    @Input() unique: number[] = []
    @Input() followUp: number[] = []
  dataTableLoaded = false;

    constructor() {
      console.log('ADMISSION CHART ',`${this.centreNames.length},${this.unique.length},${this.followUp.length}`)
    }
    ngOnInit(): void {
        this.areachart()
    }
    private areachart() {
        this.areaChartOptions = {
            series: [
                {
                    name: 'Unique Admissions',
                    data: this.unique,
                },
                {
                    name: 'FollowUp Admissions',
                    data: this.followUp,
                },
            ],
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false
                    }
                },
                foreColor: '#9aa0ac',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    borderRadius: 4,
                    // Round only the top of the whole stack, not each segment, or the
                    // boundary between unique and follow-up reads as a gap.
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last',
                    dataLabels: {
                        position: 'center',
                    },
                },
            },
            colors: ['#6973C6', '#FC8380'],
            dataLabels: {
                enabled: true,
                // A zero segment has no height, so its label would float over the axis.
                formatter: (val: any) => (val > 0 ? `${val}` : ''),
                style: {
                    fontSize: '11px',
                    colors: ['#fff'],
                },
            },
            stroke: {
                // Thin transparent stroke separates the two stacked segments.
                show: true,
                width: 1,
                colors: ['transparent'],
            },
            xaxis: {
                type: 'category',
                categories: this.centreNames,
                labels: {
                    // Centre names are long and there are ~18 of them.
                    rotate: -45,
                    rotateAlways: true,
                    trim: true,
                    style: {fontSize: '11px'},
                },
            },
            yaxis: {
                title: {
                    text: 'Admissions',
                },
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                offsetX: 0,
                offsetY: 0,
            },
            grid: {
                show: true,
                borderColor: '#9aa0ac',
                strokeDashArray: 1,
            },
            tooltip: {
                theme: 'dark',
                // Stacked columns are read per-centre, so show both series plus the total.
                shared: true,
                intersect: false,
                marker: {
                    show: true,
                },
                x: {
                    show: true,
                },
            },
        };
    }
}
